import React, { useState } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BulkUpdateDialog from "../../../../components/BulkUpdateDialog";
import VideoListAccordion from "components/VideoListAccordion";

const VideosAccordion = ({
  expanded,
  problemVideos,
  setProblemVideos,
  handleAddVideo,
  handleDeleteVideo,
  handleVideoChange,
  onChange,
  videoProviders,
  programmingLanguages,
  visibility,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const validateVideos = (parsedVideos) => {
    parsedVideos.forEach((video, index) => {
      if (!video.videoLink) {
        throw new Error(`Video at index ${index} is missing video link`);
      }
      if (!video.provider) {
        throw new Error(`Video at index ${index} is missing provider`);
      }
      if (!video.videoTitle) {
        throw new Error(`Video at index ${index} is missing title`);
      }
      if (!video.videoDescription) {
        throw new Error(`Video at index ${index} is missing description`);
      }
      if (!video.programmingLanguage) {
        throw new Error(
          `Video at index ${index} is missing programming language`
        );
      }
      if (!video.visibility) {
        throw new Error(`Video at index ${index} is missing visibility`);
      }
      if (video.previewAvailable === undefined) {
        throw new Error(`Video at index ${index} is missing preview available`);
      }
    });
  };

  const isVideoEmpty = (video) => {
    const isEmpty =
      (!video.videoLink || video.videoLink === "") &&
      (!video.videoTitle || video.videoTitle === "") &&
      (!video.videoDescription || video.videoDescription === "") &&
      (!video.programmingLanguage || video.programmingLanguage === "") &&
      (!video.visibility || video.visibility === "") &&
      (video.previewAvailable === undefined || video.previewAvailable === "");
    return isEmpty;
  };

  const handleBulkUpdateVideos = (parsedVideos) => {
    let updatedVideos = problemVideos === null ? [] : [...problemVideos];
    let videosToAdd = [...parsedVideos];

    updatedVideos = updatedVideos.map((video) => {
      if (isVideoEmpty(video) && videosToAdd.length > 0) {
        const videoToFill = videosToAdd.shift();
        return {
          ...video,
          id: video.id || `${Date.now()}-${updatedVideos.length}`,
          videoLink: videoToFill.videoLink,
          provider: videoToFill.provider,
          videoTitle: videoToFill.videoTitle,
          videoDescription: videoToFill.videoDescription,
          programmingLanguage: videoToFill.programmingLanguage,
          visibility: videoToFill.visibility,
          active: videoToFill.active !== undefined ? videoToFill.active : true,
          previewAvailable:
            videoToFill.previewAvailable !== undefined
              ? videoToFill.previewAvailable
              : true,
        };
      }
      return video;
    });

    if (videosToAdd.length > 0) {
      updatedVideos = [
        ...updatedVideos,
        ...videosToAdd.map((video, idx) => ({
          id: `${Date.now()}-${updatedVideos.length + idx}`,
          videoLink: video.videoLink,
          provider: video.provider,
          videoTitle: video.videoTitle,
          videoDescription: video.videoDescription,
          programmingLanguage: video.programmingLanguage,
          visibility: video.visibility,
          active: video.active !== undefined ? video.active : true,
          previewAvailable:
            video.previewAvailable !== undefined
              ? video.previewAvailable
              : true,
        })),
      ];
    }

    setProblemVideos(updatedVideos.length > 0 ? updatedVideos : null);
  };

  return (
    <>
      <VideoListAccordion
        title="Videos"
        problemVideos={Array.isArray(problemVideos) ? problemVideos : []}
        onAddVideo={(e) => {
          e?.stopPropagation();

          handleAddVideo();
        }}
        onDeleteVideo={(index) => {
          if (index === undefined) {
            console.error("Delete video failed: index is undefined");
            return;
          }
          handleDeleteVideo(index);
        }}
        onVideoChange={handleVideoChange}
        expanded={expanded}
        onAccordionChange={onChange}
        videoProviders={videoProviders}
        programmingLanguages={programmingLanguages}
        visibility={visibility}
        accordionKey="videos"
        additionalActions={
          expanded && (
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={(e) => {
                e.stopPropagation();
                setOpenDialog(true);
              }}
            >
              Bulk Update
            </Button>
          )
        }
      />
      <BulkUpdateDialog
        title="Bulk Update Videos"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onBulkUpdate={handleBulkUpdateVideos}
        validateInput={validateVideos}
        successMessage="Videos added successfully!"
        helperText="Enter an array of videos in JSON format (e.g., [{'videoLink': 'https://youtube.com/watch?v=abc123', 'provider': 'YOUTUBE', 'videoTitle': 'Title', 'videoDescription': 'Description', 'active': true}])"
      />
    </>
  );
};

export default VideosAccordion;
